//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vux'
import { SaafHeader, SaafScroller } from '@/common/components/index'
import { mapState } from 'vuex'
import { service, nativeApi } from '@/common/index'
import { fetch } from '@/page/index'
import storeCommon from '@/common/store/StoreCommon'

export default {
    data () {
        return {
            titleTab: localStorage.titleTab ? JSON.parse(localStorage.getItem('titleTab')).titleTab : '菜单'
        }
    },
    components: {
        SaafHeader,
        SaafScroller
    },
    computed: {
        ...mapState({
            userInfo: (state) => state.user.userInfo
        })
    },
    created () {
        // 未绑定微信公众号时，此行代码必须注释
        //this.registerWechatJsApi()
    },
    activated: function () {},
    methods: {
        // 注册微信JS-SDK
        registerWechatJsApi() {
            const _wxCallback = (sign) => {
                let _params = {
                    debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
                    appId: sign.appId, // 必填，公众号的唯一标识
                    timestamp: sign.timestamp, // 必填，生成签名的时间戳
                    nonceStr: sign.nonceStr, // 必填，生成签名的随机串
                    signature: sign.signature,// 必填，签名
                    jsApiList: ['scanQRCode'] // 必填，需要使用的 JS 接口列表
                }
                //alert(JSON.stringify(_params))
                wx.config(_params);

                wx.ready(() => {
                    // 9.1.2 扫描二维码并返回结果
                    /*wx.scanQRCode({
                      needResult: 1, // 0 是跳转  1 是返回扫描结果
                      desc: "scanQRCode desc",
                      success: (res) => {
                        //条形码返回结果会有一些莫名其妙的前缀，需要对结果做处理
                        let code = ''
                        if (res.resultStr.includes(',')) {
                          code = res.resultStr.split(',')[1]
                        } else {
                          code = res.resultStr
                        }
                        alert(code)
                        //this.getScan(code) // 拿到结果做进一步处理
                      }
                    });*/
                });
                //初始化jsapi接口 状态
                wx.error(function (res) {
                    alert("调用微信jsapi返回的状态:" + res.errMsg);
                });
            }
            let _wxInviteUrl = ""
            if (navigator.userAgent.indexOf('iPhone') !== -1) {
                _wxInviteUrl = location.href.split("#")[0]
            } else {
                _wxInviteUrl = window.location.href
            }
            //_wxInviteUrl = encodeURIComponent(_wxInviteUrl.replace("mobilewx/", "mobilewx"))
            _wxInviteUrl = encodeURIComponent(_wxInviteUrl)
            fetch.wechatJsApiGenerateSignature({url: _wxInviteUrl}).then(res => {
                _wxCallback(res.data)
            })
        },
        listLookupValues() {
            fetch.baseLookupTypeService_findDic().then(res=>{
                localStorage.setItem("lookupValues", JSON.stringify(res.data));
                this.$store.commit('SET_DIC_CODES', res.data)
            })
        },
        getRoomUserUnreadCount() {
            fetch.srmBaseImRoomUserRestful_getRoomUserUnreadCount().then(res => {
                if (res.data > 0) {
                    storeCommon.commit('SET_ROOM_UNREAD_HINTS', true)
                }
            })
        }
    },
    watch: {
        titleTab: function (val) {
            // console.log(val)
            localStorage.setItem('titleTab', JSON.stringify({titleTab: val}))
        }
    },
    mounted () {
        this.listLookupValues();
        // 获取用户未读信息数量
        // this.getRoomUserUnreadCount()
    }
}



// WEBPACK FOOTER //
// ./src/page/srm/home/tabPage.vue